import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import {
  ADD_PAYMENT_ACCOUNT_LABEL,
  PAYMENTS_ACCOUNTS_PATH,
  TABLET,
} from '@app/constants';
import { useWindowSize } from '@app/hooks';

import { usePaymentAccountsPageHeader } from '@pages/Finances/PaymentAccountsList/hooks/usePaymentAccountsPageHeader';

export const PaymentAccountsPageHeader = () => {
  const [label, setLabel] = useState(ADD_PAYMENT_ACCOUNT_LABEL);

  const { hasUserRightToCreatePaymentsAccount } =
    usePaymentAccountsPageHeader();
  const { innerWidth } = useWindowSize();

  useEffect(() => {
    if (innerWidth <= TABLET) {
      setLabel('');
    } else {
      setLabel(ADD_PAYMENT_ACCOUNT_LABEL);
    }
  }, [innerWidth]);

  if (!hasUserRightToCreatePaymentsAccount) {
    return <></>;
  }

  return (
    <Link to={`${PAYMENTS_ACCOUNTS_PATH}/add/`}>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        data-testid="add-payment-account"
      >
        {label}
      </Button>
    </Link>
  );
};
